import { FormLabel, type FormLabelProps } from "@ariakit/react";
import cn from "clsx";

import styles from "./SearchFormLabel.module.scss";

export interface SearchFormLabelProps {
  showLabel?: boolean;
  name: FormLabelProps["name"];
  text: string;
}

export function SearchFormLabel({
  showLabel,
  name,
  text,
}: SearchFormLabelProps) {
  const classes = [styles.groupTitle];

  if (!showLabel) {
    classes.push(styles.hidden);
  }

  return (
    <FormLabel className={cn(classes)} name={name}>
      {text}
    </FormLabel>
  );
}
